require("regenerator-runtime/runtime");
import axios from "axios";

const _authRequest = (token) =>
  axios.create({ headers: { Authorization: `Bearer ${token}` } });

export const makeOptionalAuthRequest = () => {
  const token = localStorage.getItem("token");
  return token ? _authRequest(token) : axios.create();
};

export const makeAuthRequest = () => {
  const token = localStorage.getItem("token");
  return _authRequest(token);
};

export const defaultQueryFn = async ({ queryKey }) => {
  const { data } = await makeOptionalAuthRequest().get(queryKey[0]);
  return data;
};
